import React, { Component } from 'react';
import {Scatter} from 'react-chartjs-2';
import LoadingOverlay from 'react-loading-overlay';
import { IoIosArrowBack,IoIosArrowForward } from "react-icons/io";
import {BmiController} from '../controllers/Bmi';
import height22 from '../images/height22.jpg';
import weight_measure122 from '../images/weight_measure122.png';
export const GrowthChart =  class GrowthChart extends Component {
    constructor(props){
        super(props);
        this.state = {
            metric: 'weight',
            range: 'months',
            lower_scale_limit: null,
            uper_scale_limit: null,
            growth_progress_data: [],
            age_vs_metric_data: [],
            fetch_data: true,
            error: null,
            loading: true,
        }
    }

    minimizeLimit = () => {
        const {age} = this.props;
        const total_months = age.total_months;

        const rem = total_months % 10;
        var int = Math.floor(total_months/10);

        if(rem === 0 && int !== 0)
            int -= 1;

        var min_scale_limit = int*10;
        var max_scale_limit = min_scale_limit + 10;

        const state = this.state;
        state.lower_scale_limit -= 10;
        state.uper_scale_limit -= 10;

        if(state.lower_scale_limit  < 0){
            state.lower_scale_limit  = 0;
            state.uper_scale_limit = 10;
        }

        state.fetch_data = true;

        this.setState(state);
    }

    maximizeLimit = () => {
        const {age} = this.props;
        const total_months = age.total_months;

        const rem = total_months % 10;
        var int = Math.floor(total_months/10);

        if(rem === 0 && int !== 0)
            int -= 1;

        var min_scale_limit = int*10;
        var max_scale_limit = min_scale_limit + 10;

        const state = this.state;
        state.lower_scale_limit += 10;
        state.uper_scale_limit += 10;

        if(state.uper_scale_limit > 60){
            state.uper_scale_limit = 60;
            state.lower_scale_limit = 50;
        }

        if(state.uper_scale_limit > max_scale_limit){
            state.uper_scale_limit = max_scale_limit;
            state.lower_scale_limit = min_scale_limit;
        }

        state.fetch_data = true;

        this.setState(state);
    }

    setData = () => {

        const {age} = this.props;
        const total_months = age.total_months;

        const rem = total_months % 10;
        var int = Math.floor(total_months/10);

        if(rem === 0 && int !== 0)
            int -= 1;

        var min_scale_limit = int*10;
        var max_scale_limit = min_scale_limit + 10;

        var lower_scale_limit_temp, uper_scale_limit_temp;

        if(total_months <= 10){
            lower_scale_limit_temp = 0;
            uper_scale_limit_temp = 10;
        }
        else if(total_months <= 20){
            lower_scale_limit_temp = 10;
            uper_scale_limit_temp = 20;
        }
        else if(total_months <= 30){
            lower_scale_limit_temp = 20;
            uper_scale_limit_temp = 30;
        }
        else if(total_months <= 40){
            lower_scale_limit_temp = 30;
            uper_scale_limit_temp = 40;
        }
        else if(total_months <= 50){
            lower_scale_limit_temp = 40;
            uper_scale_limit_temp = 50;
        }
        else if(total_months <= 60){
            lower_scale_limit_temp = 50;
            uper_scale_limit_temp = 60;
        }


        if(uper_scale_limit_temp > max_scale_limit){
            uper_scale_limit_temp = max_scale_limit;
            lower_scale_limit_temp = min_scale_limit;
        }

        this.setState({lower_scale_limit: lower_scale_limit_temp, uper_scale_limit: uper_scale_limit_temp});

    }

    toWeight = () => {
        this.setState({metric: 'weight', fetch_data: true});
    }

    toHeight = () => {
        this.setState({metric: 'height', fetch_data: true});
    }

    componentDidMount() {
        this.setData();
    }

    render() { 

        var metric_label = '';
        var SIUnit, extension, weight_select, height_select, metric_label, fill1, fill2, fill3, title;

        const { metric, range, lower_scale_limit, uper_scale_limit, growth_progress_data, error, fetch_data, age_vs_metric_data, loading } = this.state;
        const { Child, User, age, Translator, card} = this.props;
        const translation = Translator;
        const total_months = age.total_months;

        if(fetch_data){
            let age_vs_metric_data = BmiController.getAgeVsMetricData(metric,this.props.Child.sex);
            BmiController.getGrowthProgressData(metric,range,Child,User).then((res) => {
                if(res.success)
                    this.setState({growth_progress_data: res.data, fetch_data: false,age_vs_metric_data: age_vs_metric_data,  loading: false});
                else
                    this.setState({fetch_data: false,age_vs_metric_data: age_vs_metric_data, error: res.error, loading: false});
            }).catch((error) => {
                alert(error);
            });
        }

        if(metric === 'weight'){
            SIUnit = 'kg';
            extension = 'w';
            weight_select = 'selected="selected"';
            metric_label = translation['growth_chart_y_axis_weight'];
            title = Child.first_name+' '+Child.last_name+' '+translation['growth_chart_weight_title'];
        }
        else if(metric == 'height'){
            SIUnit = 'cm';
            extension = 'lh';
            height_select = 'selected="selected"';
            metric_label = translation['growth_chart_y_axis_height'];
            title = Child.first_name+' '+Child.last_name+' '+translation['growth_chart_height_title'];

        }
        if(card == 'book_card'){
            fill1 = 'false';
            fill2 = 'false';
            fill3 = 'false';
        }
        else{
            fill1 = 'origin';
            fill2 = 1;
            fill3 = 2;
        }

        const progress_size = growth_progress_data.length;
        const metric_data_size = age_vs_metric_data.length;
        
        const labels = [];
        const progress_data = [];
        const severe_data = [];
        const mild_data = [];
        const normal_data = [];

        var j;
        for(j = 0; j < progress_size; j++){
            if(growth_progress_data[j][range] < lower_scale_limit || growth_progress_data[j][range] > uper_scale_limit)
                continue;
            progress_data.push({x: growth_progress_data[j][range], y: growth_progress_data[j][metric]});
        }
        var i;
        for(i = 0; i < metric_data_size; i++){
            if(age_vs_metric_data[i]['Month'] < lower_scale_limit || age_vs_metric_data[i]['Month'] > uper_scale_limit)
                continue;
            severe_data.push({x: age_vs_metric_data[i]['Month'], y: age_vs_metric_data[i][`-3SD_${extension}`]});
            mild_data.push({x: age_vs_metric_data[i]['Month'], y: age_vs_metric_data[i][`-2SD_${extension}`]});
            normal_data.push({x: age_vs_metric_data[i]['Month'], y: age_vs_metric_data[i][`2SD_${extension}`]});
        }

        const chartData = {
            labels:['Scatter'],
            datasets:[
                {
                    label:translation['progress_status'],
                    fill:false,
                    borderColor: "black",
                    pointBorderColor: "black",
                    pointBackgroundColor: "black",
                    backgroundColor: "black",
                    borderWidth: 0.4,
                    showLine:true,
                    data:progress_data
                },
                { 
                    label:translation['severe_status'],
                    fill:fill1,
                    pointRadius: 0,
                    pointHitRadius: 0,
                    showLine:true,
                    data:severe_data,
                    backgroundColor: "red",
                    borderColor: "red"
                },
                {
                    label:translation['mild_status'],
                    fill:fill2,
                    pointRadius: 0,
                    pointHitRadius: 0,
                    showLine:true,
                    data:mild_data,
                    backgroundColor: "grey",
                    borderColor: "grey"
                },
                {
                    label:translation['normal_status'],
                    fill:fill3,
                    pointRadius: 0,
                    pointHitRadius: 0,
                    showLine:true,
                    data:normal_data,
                    backgroundColor: "green",
                    borderColor: "green"
                }
            ],

        }


        const mainStyle = {
            height: "320px",
            backgroundColor:"#d3d3d3",
            // overflow: "hidden"
        }
        return (  
            <div style={mainStyle}>
                <LoadingOverlay active={loading} spinner text='Fetching data...'>
                <div className="container-fluid" style={{backgroundColor:"#fff"}}>
                    <div className="row pt-3">
                        <div className="col-2 col-md-2 col-sm-2">
                            <button onClick={this.minimizeLimit} style={{border: '0px',backgroundColor: '#fff',outline: 'none',fontSize: '1.3em'}}><span><IoIosArrowBack /></span></button>
                        </div>
                        <div className="col-8 col-md-8 col-sm-8 row">
                            <div className="col-6 col-md-6 col-sm-6">
                            <a href="#"><button onClick={this.toHeight} style={{border: '0px',backgroundColor: '#fff'}}><img src={height22} alt="" height="30px" width="40px"/></button></a>
                            </div>
                            <div className="col-6 col-md-6 col-sm-6">
                            <a href="#"><button onClick={this.toWeight}  style={{float:'right',border: '0px',backgroundColor: '#fff'}}><img src={weight_measure122} alt="" height="30px"/></button></a>
                            </div>
                        </div>
                        <div className="col-2 col-md-2 col-sm-2 pr-0">
                            <button onClick={this.maximizeLimit} style={{float: 'right',border: '0px',backgroundColor: '#fff',outline: 'none',fontSize: '1.3em'}}><span><IoIosArrowForward/></span></button>
                        </div>
                    </div>
                    <div className="row pt-2">
                        <div className="col-12 col-md-12 colsm-12">
                            <Scatter
                              data = {chartData}
                              width={100}
                              height={320}
                              options = {{
                                devicePixelRatio: 1,
                                responsive: true,
                                maintainAspectRatio: false,
                                aspectRatio: 1,
                                title:{
                                    display:true,
                                    text:title,
                                    position:'top'
                                },
                                legend: {
                                    display: true,
                                    position: 'bottom',
                                    fullWidth: false,
                                    labels: {
                                        fontColor: '#000',
                                        boxWidth: 15,
                                    }
                                },
                                scales: {
                                    yAxes: [{
                                        type: 'linear',
                                        scaleLabel: {
                                            display: true,
                                            labelString: `${metric_label} (${SIUnit})`,
                                            fontColor: "#000",
                                            fontSize: 11
                                        }
                                    }],
                                    xAxes: [{
                                        position: 'bottom',
                                        ticks: {
                                            min: lower_scale_limit,
                                            stepSize: 1,
                                        },
                                        scaleLabel: {
                                            display: true,
                                            labelString: translation['growth_chart_x_axis'],
                                            fontColor: "#000",
                                            fontSize: 11
                                        }
                                    }]
                                   
                                },
                              }}
                            />
                        </div>
                    </div>
                </div>
                </LoadingOverlay>
                {/* ) : (<div style = {{textAlign: "center"}}>Fetching data...</div>) } */}
            </div>
           
        );
    }
}
 
export default GrowthChart;